import { Link, Popover, SpaceBetween } from "@cloudscape-design/components";
import { mdiCardAccountPhoneOutline, mdiEmailArrowRightOutline, mdiPhoneOutgoingOutline, mdiWhatsapp } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { formatPhone, getUser } from "../../pages/commons/functions";
import { useGlobalState } from "../../pages/context/GlobalStateContext";
import UserAvatar from "./UserAvatar";

type PopOverContactProps = {
  idUser: number;
  hideUser?: boolean;
  tooltip?: boolean;
  content?: string;
  triggerType?: "custom" | "text" | "text-inline";
};

const PopOverContact: React.FC<PopOverContactProps> = ({ idUser = 0, tooltip = true, hideUser = false, content = "", triggerType = "custom" }) => {

  const { data, parameters } = useGlobalState();

  return (
    <SpaceBetween size="xs" direction="horizontal">
      {!hideUser ? getUser(idUser, data)?.displayName : null}
      <Popover
        triggerType={triggerType}
        dismissButton={false}
        header={getUser(idUser, data)?.displayName}

        renderWithPortal
        content={
          <SpaceBetween size="m" direction="vertical">

            <UserAvatar idUser={idUser} />
            <SpaceBetween size="xs">
              <div><strong>Teléfono:</strong> {formatPhone(getUser(idUser, data)?.phone1)}</div>
              <div><strong>Email:</strong> {getUser(idUser, data)?.email}</div>
              <SpaceBetween size="s" direction="horizontal">
                <Link href={`tel:+${getUser(idUser, data)?.phone1}`}><Icon path={mdiPhoneOutgoingOutline} size={1} /></Link>
                <Link href={`https://wa.me/${getUser(idUser, data)?.phone1}`}><Icon path={mdiWhatsapp} size={1} /></Link>
                <Link href={`mailto:${getUser(idUser, data)?.email}`}><Icon path={mdiEmailArrowRightOutline} size={1} /></Link>
              </SpaceBetween>
            </SpaceBetween>
          </SpaceBetween >

        }>{content === "" ? <Icon path={mdiCardAccountPhoneOutline} size={0.6} /> : content}

      </Popover >
    </SpaceBetween >
  );
};

export default PopOverContact;
